import {ModuleConfiguration} from "../router/model/UserPermission";
import {MULTICOLUMN_LIST_MODULE_NAME} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const MulticolumnListModule = new ModuleConfiguration(MULTICOLUMN_LIST_MODULE_NAME,
    [AngularJsMaterialModuleName]);